
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexC6kXUglCUF_45O0dyrKcn5AAopLmtT96F9r9B1QSyQxF4Meta } from "/tmp/build_6916f5cc/pages/app/me/index.vue?macro=true";
import { default as mehOaUX_45n3aVbenXn03zhW39SXyehsPY2afulSVUrSTrUMeta } from "/tmp/build_6916f5cc/pages/app/me.vue?macro=true";
import { default as mapvxak8OrOz3XDNTu9FZd70VDCX7q09Zt9J4Y_R7uDBVMMeta } from "/tmp/build_6916f5cc/pages/app/map.vue?macro=true";
import { default as postAST28kLTghpNPRBXpDZdfXvViGE3O7tO37YMEqZMuPQMeta } from "/tmp/build_6916f5cc/pages/app/feed/post.vue?macro=true";
import { default as indexIKP8dSsipEA2OwubdDAfefQziB0uIjSvwtwyzKWUjwQMeta } from "/tmp/build_6916f5cc/pages/app/feed/index.vue?macro=true";
import { default as _91type_93p6hEXi77MnQVayAXl2Ssl4dw2WMg_45DoUyXDWaGZK7hwMeta } from "/tmp/build_6916f5cc/pages/app/feed/[type].vue?macro=true";
import { default as feedh_45GvIs_45JFSEDHq_45wtWZGy_45VRhtfYzCwGidZwyMGiHcMMeta } from "/tmp/build_6916f5cc/pages/app/feed.vue?macro=true";
import { default as indexl4HhT0JtFC3Lr1kEZzL7p2VIZqAW3Snxn_452q6DnBc7gMeta } from "/tmp/build_6916f5cc/pages/app/index.vue?macro=true";
import { default as eulaAAIgPLxP8Zw5MBlMmzv1Hi2Gg5BAU2yyu49qHHEHBocMeta } from "/tmp/build_6916f5cc/pages/main/eula.vue?macro=true";
import { default as quizqoHQw7eqoTWGgRkEQDu9ERw1MJrGTJMzMX_o5jiimEIMeta } from "/tmp/build_6916f5cc/pages/admin/quiz.vue?macro=true";
import { default as indexqTovBx0ThfbvaqVR2JFMpd_45zQ9_45C8z9SMzX7LhVf3ZYMeta } from "/tmp/build_6916f5cc/pages/app/groups/index.vue?macro=true";
import { default as editOOCVLpggRHZJTCDtSZA3_45NF_45LYsRSrsR1kLLq_SdK3EMeta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as about5qSbGZlOiaTjOY8g7g2g5fJ2gCtG0BqzzVmzZ7_45hlwMMeta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexjYUNz9EZekmNLG7p8EKWHT0rE5s5ONFo420VCZMz6MAMeta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsYNnQ0qieyZDE7uK7f_45db6x2Q_45CXDnXpsZ0PUK5SxTh8Meta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersUqkmui2B38V2o_4554_45PSSvYOhlW3qLn7zR0IHoKX5HKwMeta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsg9cER8Zps0Yr1I6Cfwg0LoEg0k_45vlQCwxtaeGwjIxBQMeta } from "/tmp/build_6916f5cc/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_938IyFBXJVLJbJ8zazjoKgfxB8TKrKT_45BYP2pCjjJHMX8Meta } from "/tmp/build_6916f5cc/pages/app/groups/[slug].vue?macro=true";
import { default as createTNf_45R4hqVaK3SdR_45D7Vzm3ZC_45uHConfgkY6WGk3hK5YMeta } from "/tmp/build_6916f5cc/pages/app/groups/create.vue?macro=true";
import { default as groupsaB5yuJ5f67JfWHwTPqcDHtsOz_45bRN_45oMeCWwydoU_45iIMeta } from "/tmp/build_6916f5cc/pages/app/groups.vue?macro=true";
import { default as index0Qaq4WYRhZYKMVWEyu1OsThHx5tvHeeq_4UBHDhUmZYMeta } from "/tmp/build_6916f5cc/pages/app/params/index.vue?macro=true";
import { default as accountz40epa5AK6xxnrKBKorACqCcGYNUJnQLkuNeWXhRyr0Meta } from "/tmp/build_6916f5cc/pages/app/params/account.vue?macro=true";
import { default as transactionsW0Y5UqV_fzYklWiLMJ7_451ZaH_L3oNS2YaISUejz43fUMeta } from "/tmp/build_6916f5cc/pages/app/params/transactions.vue?macro=true";
import { default as paramsebvLyQC4ajZy_45qWW8GG83dqllGsojqOfuc_yy0rw_45kkMeta } from "/tmp/build_6916f5cc/pages/app/params.vue?macro=true";
import { default as indexwNO3fEI0aFqL87cyLi22RtZkM73bLhs_XFsjXStWsOcMeta } from "/tmp/build_6916f5cc/pages/main/index.vue?macro=true";
import { default as presscHzg4SXHoXmIdfoEmEUpZR_66fJqIh3UhA6vzCfSpqgMeta } from "/tmp/build_6916f5cc/pages/main/press.vue?macro=true";
import { default as codesnK9y50h3_45Wsaj3zAcLXActmNbc91_45f_45fzCAVKJ8yIDYMeta } from "/tmp/build_6916f5cc/pages/admin/codes.vue?macro=true";
import { default as indexT7x9jd_t1bV7dEeyDiYM1baNdUkUSMoAM7N_45FEw6CEkMeta } from "/tmp/build_6916f5cc/pages/admin/index.vue?macro=true";
import { default as indexgBibZHeCEkEk23SPbDl_454fezSv_NLtVJCRTWQf5rwZUMeta } from "/tmp/build_6916f5cc/pages/app/hangout/index.vue?macro=true";
import { default as agendaIpUDewCxJ88f_45BYMyLgqOA_45eG4JXha7gu4yYFXfq26gMeta } from "/tmp/build_6916f5cc/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupshtqM5NamzHIzRibPtc57URPmK_qgbqzUHoi203tLwz8Meta } from "/tmp/build_6916f5cc/pages/app/hangout/meetups.vue?macro=true";
import { default as organizequeyYLUrvgDMFhIzv0jW3Z_454NOfQC6sO_YfReA1WjS4Meta } from "/tmp/build_6916f5cc/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutttuuNhcO1HI2wvtAy2G_45SmCqNQLl54eD6oNbMPMsp_45EMeta } from "/tmp/build_6916f5cc/pages/app/hangout.vue?macro=true";
import { default as charte3aMTyDMmLxvMmf7VDb0KGLLd3YtYS60hNxK0dMqhBWQMeta } from "/tmp/build_6916f5cc/pages/main/charte.vue?macro=true";
import { default as francesDS47bji2edHg3ikxztBYt37bTnGQOFCvvxXF2Z_45rFEMeta } from "/tmp/build_6916f5cc/pages/main/france.vue?macro=true";
import { default as themesDenwjJ2Cme_45DhP_BwgaH8PGzmdkke6_45r2Jiuun83qo4Meta } from "/tmp/build_6916f5cc/pages/admin/themes.vue?macro=true";
import { default as indexs5kRgBRIalmi7VcbGi2JhxGG7cseo7fGni0pZ_45DkkdkMeta } from "/tmp/build_6916f5cc/pages/app/insiders/index.vue?macro=true";
import { default as suggestionslLdwprSP1_45a_45eCpDQ5z6wRlG3wyZ9A5zwAooFXp1BL0Meta } from "/tmp/build_6916f5cc/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersPpvlv2fzAvraWx0EHlE62jZ2bI4dN1nnF8NrNCz1N8IMeta } from "/tmp/build_6916f5cc/pages/app/insiders.vue?macro=true";
import { default as messages_45s7L2okk2Jr46VrNClHmxalkEMtYefoyZIFgv_45WK6d4Meta } from "/tmp/build_6916f5cc/pages/app/messages.vue?macro=true";
import { default as privacyVgRgymIndLq5_CSlWwUBZqcvubAFIe_45WxptwRcl_45jeIMeta } from "/tmp/build_6916f5cc/pages/main/privacy.vue?macro=true";
import { default as trainerMhAd7p_45EJ6W1EKpt1jobajKlsEJLOC_Uv9WIFNm7paAMeta } from "/tmp/build_6916f5cc/pages/admin/trainer.vue?macro=true";
import { default as indexvSKHjvU_45SyLW6gf_bBLyfR412OaOE0GlA6cVUfz2T8wMeta } from "/tmp/build_6916f5cc/pages/app/community/index.vue?macro=true";
import { default as searchTv8_9YKNC1xmJtWkxljngmkwfxr4_45T6gANEGYJ5ikwEMeta } from "/tmp/build_6916f5cc/pages/app/community/search.vue?macro=true";
import { default as besties8FDEviPZ1W42U9jHbDNRJFO0rY_73fpkcs_oM9JobVQMeta } from "/tmp/build_6916f5cc/pages/app/community/besties.vue?macro=true";
import { default as indexPEuymqSpL3bkebX9oTCNzAh0WTXlU_45UfYr_tKFJ9QJ4Meta } from "/tmp/build_6916f5cc/pages/app/community/[type]/index.vue?macro=true";
import { default as communityQZspTEX4UbIUwak4KsoiUYbEVaNhQah2jhztr5zru64Meta } from "/tmp/build_6916f5cc/pages/app/community.vue?macro=true";
import { default as index_457qRlmgcvuM_45zqKKE_45Ifo241bqM9tXhY2yw0YlnmHfkMeta } from "/tmp/build_6916f5cc/pages/app/quiz/[id]/index.vue?macro=true";
import { default as _91id_93zLbhPri29sWk407EJlIwdRhuKiYqtVQ2N4MqXut3MEwMeta } from "/tmp/build_6916f5cc/pages/app/quiz/[id].vue?macro=true";
import { default as indexzbcgECOChgRyLKwYEp6E4NoeSd3RneYl0mXSSQoj_QQMeta } from "/tmp/build_6916f5cc/pages/app/auth/index.vue?macro=true";
import { default as abouts_LjFz_45WqX5AqeUk_pX2j10zqJXOG42g9tsv_45pxpHMkMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/about.vue?macro=true";
import { default as emailw3fLSz4VhgOTq_zpmHpsQxqxAU_45_45XqEpMDh9D7heLocMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/email.vue?macro=true";
import { default as goalsJHIOPVyF2yL5SXVm20EKb0GQsDD9_CHGBuZtaZ3UnUsMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/goals.vue?macro=true";
import { default as indexYuLG806sLyRSp44cmuoyvVYJ7mGyQ4INu9EV9f1HAcAMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/index.vue?macro=true";
import { default as phoneaC31XCebZN_45A_45QDFPiaQgODQnjT_458gyy_45A0cI75g_45ooMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsDnyHxGzFnWIHEeHUEhB29GkkIIIiKDaWQXTW_45GcWCbAMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/groups.vue?macro=true";
import { default as searchDE35gj46bNfcmgCH2D8xgrc6nv93l41TgExRgwTHT_4Meta } from "/tmp/build_6916f5cc/pages/app/onboarding/search.vue?macro=true";
import { default as chartertag65wcOjkhRj0IJhiZFrM3sMhwY499aYkTTnvb6xPoMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingKtS2b0nW7QNRaXMpu07PTdgR_LgtZSimHTEnacWPt4wMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/loading.vue?macro=true";
import { default as profileySIUFqeW_45IwfTM09edpBUv6SJIA9CBGTrzRfe6fRIywMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/profile.vue?macro=true";
import { default as identityPy0A9T79DX53r3Wue1UQtPQowrDUpELIK1yCXr4WfvwMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/identity.vue?macro=true";
import { default as profiles0udyqCEoLVW0yERQvlB7ufCnBKrcVxAGwx9oGaE0nK4Meta } from "/tmp/build_6916f5cc/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipxcJWCZbxFXPeSNZhJFc_451aERTlviK_JWqT_45kMnFFMp8Meta } from "/tmp/build_6916f5cc/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsTgHdh_45gMANi4QQ7lUwnBreBwMqpnKxOb70ct_70cUygMeta } from "/tmp/build_6916f5cc/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardingUncLjBNVsnRLIz8kQU2V6FN17WWv1xG3XHhwSgxNUu0Meta } from "/tmp/build_6916f5cc/pages/app/onboarding.vue?macro=true";
import { default as indexeUdh4JFV0Q2jNBdSYoBv5InFV1KrU8ehX_JL074VR4kMeta } from "/tmp/build_6916f5cc/pages/app/quiz/index.vue?macro=true";
import { default as investorsqxlgzg9L13T_45nu9cUL2oLEN4HFSZ9mrb258fgXywOJEMeta } from "/tmp/build_6916f5cc/pages/main/investors.vue?macro=true";
import { default as _91id_93SP5WrbJQEfSXwNT2i4AWtLcPXG9kM0nZHYqvAB2PsHkMeta } from "/tmp/build_6916f5cc/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastyKPvCXjtPetUoYV3aiAmeacfIZ3U1WxX6SPJHD5VY4sMeta } from "/tmp/build_6916f5cc/pages/admin/broadcast.vue?macro=true";
import { default as deletepjl1o6kT244cG85Sz_qpaNyv_45dOjqOoFbIjTLjhLXwYMeta } from "/tmp/build_6916f5cc/pages/app/auth/delete.vue?macro=true";
import { default as logoutMaAuqssJhs_45RqxdPCdT7WPzz16zYyXvEBt7uPFFaPjYMeta } from "/tmp/build_6916f5cc/pages/app/auth/logout.vue?macro=true";
import { default as indexjGLdJ5f492Mn0NbEE6OJwT8uIAPP3jPCUCKGSBQQMfIMeta } from "/tmp/build_6916f5cc/pages/app/story/index.vue?macro=true";
import { default as indexr_45NbgyqCGU0uRanLAlWE_Ltn_ZZIHx_45ikOoIzuJ3qAoMeta } from "/tmp/build_6916f5cc/pages/backstage/index.vue?macro=true";
import { default as indexgFiEzvXRmabohSSgidL4Yf2f63tOkE1wjZRopn2wOV4Meta } from "/tmp/build_6916f5cc/pages/main/auth/index.vue?macro=true";
import { default as indexs3j5GGvZ2jep06OrTLHnu3P8ufGElbYhXsftfxULlNgMeta } from "/tmp/build_6916f5cc/pages/main/blog/index.vue?macro=true";
import { default as indexKMzEa4grTvg5WUl__45pB8WQeg8ELpQc3vUvZ1kwecjnwMeta } from "/tmp/build_6916f5cc/pages/admin/auth/index.vue?macro=true";
import { default as indexglbtBRvQhKmcBonmgWlnEu8tdJd0anzdEnCPdDJrpeYMeta } from "/tmp/build_6916f5cc/pages/admin/blog/index.vue?macro=true";
import { default as deleteKjhBxAkSMu5e9TxwjWkznKGFoiFpCVSdWggvhW8UnjYMeta } from "/tmp/build_6916f5cc/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93gy1s3_45UK1pbibc1wVrSJgEL5L4eZD0ktEgvy6_45vxZ2cMeta } from "/tmp/build_6916f5cc/pages/main/blog/[slug].vue?macro=true";
import { default as index8v14M9Laf6h8WvaN7bhwCdX88gEjWtRh8j8TeSyvph8Meta } from "/tmp/build_6916f5cc/pages/main/event/index.vue?macro=true";
import { default as _91token_93_M_SKBpxMGHL9ttfaXQY7FNmQKrT5kUjbqWnHeU_4543QMeta } from "/tmp/build_6916f5cc/pages/payments/[token].vue?macro=true";
import { default as editrhBWUdZELrtrT2Ncsmbv_MGDZyWjgrf0vRRVumfjuWMMeta } from "/tmp/build_6916f5cc/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexKPo1F0eerecO3bhFoX6VJsw8Ot2hcTEthUljqJloa_sMeta } from "/tmp/build_6916f5cc/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93NNToJhfSOwY9WjrhNeztQul2QFPxOtufG5ZQNcPbCzIMeta } from "/tmp/build_6916f5cc/pages/app/events/[slug].vue?macro=true";
import { default as createm1b0BB_45fBfQRjjYuxa9yHwLGUi5JY5LuljzGQc4s1BQMeta } from "/tmp/build_6916f5cc/pages/app/events/create.vue?macro=true";
import { default as listMeocdr7_45kTEmf4wy_VNwwVYMtJlmiBBNomBA_45yEHLQQMeta } from "/tmp/build_6916f5cc/pages/app/partners/list.vue?macro=true";
import { default as _91slug_93WLck9CZzsNfM6p5D7OHkXtceYWWdtBIkxIdUYy2afwsMeta } from "/tmp/build_6916f5cc/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93_WwvbOY70KPD19JQbBaq9hBfpOPVxjmmnZHtkPkTdMIMeta } from "/tmp/build_6916f5cc/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93KiIqlQO7rba_45NAmpvd6sRisoZrC8b9M6R9CWlRzBE3IMeta } from "/tmp/build_6916f5cc/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93eLJobskSEkXRS4YChIY2UUgesVmQG4RdduT7NKn6hk4Meta } from "/tmp/build_6916f5cc/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93RzXI1l7D10_VwxTzEF5emZJD00knpsZRY8gWVgaTzBwMeta } from "/tmp/build_6916f5cc/pages/main/invite/[slug].vue?macro=true";
import { default as organizations4pYPRdu3uLBqetDcPLMctd__451u4TVd3B92kvFoQNaRkMeta } from "/tmp/build_6916f5cc/pages/admin/organizations.vue?macro=true";
import { default as indexapu9_fUNIfaKvvlmqQcblKMdvgiHWQs8Agzb__45guUqQMeta } from "/tmp/build_6916f5cc/pages/admin/reports/index.vue?macro=true";
import { default as eventsFPxHZkcl16hPsU_LvUQfyeCZWrv0VNB9D_45E_45iKJQoz4Meta } from "/tmp/build_6916f5cc/pages/admin/reports/events.vue?macro=true";
import { default as preferencesMcdVzZXYCaRQTOvE_F9V_45anj7ODy_mYDombFgVQItxIMeta } from "/tmp/build_6916f5cc/pages/app/auth/preferences.vue?macro=true";
import { default as loginkgmBYbeUCq2pikKy_wOsoz27kND8NUEVNB8RxXWPRU8Meta } from "/tmp/build_6916f5cc/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93w_Sso8dtmrvfZQ_45DodSxhMasmuXetQU4YLaROR_45kA1UMeta } from "/tmp/build_6916f5cc/pages/app/conversation/[id].vue?macro=true";
import { default as logoutaJhfs1HXsAwgTwOxr2t2POqxOvf29Dvzkty5k9hQunwMeta } from "/tmp/build_6916f5cc/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencess8yhbbCVK7IM8FkRv5igp8Hxu4Dz1ahQQ_45t4ixoan5IMeta } from "/tmp/build_6916f5cc/pages/main/auth/preferences.vue?macro=true";
import { default as listCSHzwSfKnnzGEQ_45DucCQR1Y_45oiyQita2J_7KLihtvHEMeta } from "/tmp/build_6916f5cc/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93Kktj0_8S3337exocalhtiAKkj77A6CXdm_45ae5zR9XzwMeta } from "/tmp/build_6916f5cc/pages/app/auth/verify/[token].vue?macro=true";
import { default as registerixmnpsf8LZeW9M6hGgaSiMLuESobPyaQ6wXewDQFpMIMeta } from "/tmp/build_6916f5cc/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93d23Xa5XFrHyg_45327XIZjRB_453NYe_45feHHl3JCm_OXiwwMeta } from "/tmp/build_6916f5cc/pages/backstage/invite/[code].vue?macro=true";
import { default as discordqIT22_45RRniyj8lLqSOibr7F0KfWwlB_kKpdXFFUbcX0Meta } from "/tmp/build_6916f5cc/pages/app/integrations/discord.vue?macro=true";
import { default as indexwqkxYfKgTb20UUPoxN4IUpejG9stt8vCxCrDUdQVFLIMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentesv9uPQmHe_FFk7IU8oM202_Z1XPo_5ILJE8VYic5jAeUMeta } from "/tmp/build_6916f5cc/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45auth0iracEJHkrcK_45zs3aavUl8pkfG0TQJVxyq9b8a6wK6AMeta } from "/tmp/build_6916f5cc/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribeSvtgoMY59dUk6IybEGbX8pnRZzDcH4webttVqSYpiA4Meta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexXNfHwGwaCke5QZxUJJQ0g24WvOxQYRpG5n1zmKNZkjkMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexMI8yEIWQrDCCw0S8ko9TZYS8fB_453YYP27qjelocpP7UMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexSwqKPVWVNzjLY7nP_eHdXuCBP65BqVUWf83R1T0Yo5AMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsS0ufo14j_45rHtvDb7XjdXuzh_45wtjDV1Gt9vIfE2BMBBkMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedUNd7KfIjM6fP_45Tev1moXU8N1prxkn2pXVUX_45ZZzOC5AMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendeesdERv9mggqFkC_xCQvLxsdaF_jh0t8I390r9OK9RMGjwMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as editfu3c086jzLShaVxVnBuFSx2j50tv7JqphtUN5HvB84cMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexq0py71Shokz3sfU_omHDvKAZtKeN25Y1ZySnZCkSNbkMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesv9oHrICOLSW49jhrVCo6ky6jpPjgPtuii72iSi59ADIMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93b7xcRW2xfSiu20ZLOuVJ0kh_45IVoqmAtc9_45_dmOOdTccMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as creategxdSbu1_45Lv3o8V_456FSNwLCRDM4L3CbXpt9s_45fo8vE8UMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as index1FbxpxZkK3ktxjmGe7tfFJ_4Wp_fOP0boUJ5mKrbPdYMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as index8mtCbOvq7bddswHg1N8baO0aZu_RjljnsJ9EmwTM1ekMeta } from "/tmp/build_6916f5cc/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stubnzBTqPYdGdmX1a5fprjyTe12naLBvBOqUEht6uPTwoYMeta } from "/tmp/build_6916f5cc/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnzBTqPYdGdmX1a5fprjyTe12naLBvBOqUEht6uPTwoY } from "/tmp/build_6916f5cc/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: mehOaUX_45n3aVbenXn03zhW39SXyehsPY2afulSVUrSTrUMeta?.name,
    path: "/app/me",
    meta: mehOaUX_45n3aVbenXn03zhW39SXyehsPY2afulSVUrSTrUMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mapvxak8OrOz3XDNTu9FZd70VDCX7q09Zt9J4Y_R7uDBVMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/map.vue")
  },
  {
    name: feedh_45GvIs_45JFSEDHq_45wtWZGy_45VRhtfYzCwGidZwyMGiHcMMeta?.name,
    path: "/app/feed",
    meta: { ...(feedh_45GvIs_45JFSEDHq_45wtWZGy_45VRhtfYzCwGidZwyMGiHcMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postAST28kLTghpNPRBXpDZdfXvViGE3O7tO37YMEqZMuPQMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexIKP8dSsipEA2OwubdDAfefQziB0uIjSvwtwyzKWUjwQMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93p6hEXi77MnQVayAXl2Ssl4dw2WMg_45DoUyXDWaGZK7hwMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(indexl4HhT0JtFC3Lr1kEZzL7p2VIZqAW3Snxn_452q6DnBc7gMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaAAIgPLxP8Zw5MBlMmzv1Hi2Gg5BAU2yyu49qHHEHBocMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/eula.vue")
  },
  {
    name: "admin-quiz",
    path: "/admin/quiz",
    meta: { ...(quizqoHQw7eqoTWGgRkEQDu9ERw1MJrGTJMzMX_o5jiimEIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/quiz.vue")
  },
  {
    name: groupsaB5yuJ5f67JfWHwTPqcDHtsOz_45bRN_45oMeCWwydoU_45iIMeta?.name,
    path: "/app/groups",
    meta: { ...(groupsaB5yuJ5f67JfWHwTPqcDHtsOz_45bRN_45oMeCWwydoU_45iIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/index.vue")
  },
  {
    name: _91slug_938IyFBXJVLJbJ8zazjoKgfxB8TKrKT_45BYP2pCjjJHMX8Meta?.name,
    path: ":slug()",
    meta: _91slug_938IyFBXJVLJbJ8zazjoKgfxB8TKrKT_45BYP2pCjjJHMX8Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createTNf_45R4hqVaK3SdR_45D7Vzm3ZC_45uHConfgkY6WGk3hK5YMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramsebvLyQC4ajZy_45qWW8GG83dqllGsojqOfuc_yy0rw_45kkMeta?.name,
    path: "/app/params",
    meta: { ...(paramsebvLyQC4ajZy_45qWW8GG83dqllGsojqOfuc_yy0rw_45kkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(index0Qaq4WYRhZYKMVWEyu1OsThHx5tvHeeq_4UBHDhUmZYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountz40epa5AK6xxnrKBKorACqCcGYNUJnQLkuNeWXhRyr0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsW0Y5UqV_fzYklWiLMJ7_451ZaH_L3oNS2YaISUejz43fUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexwNO3fEI0aFqL87cyLi22RtZkM73bLhs_XFsjXStWsOcMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: presscHzg4SXHoXmIdfoEmEUpZR_66fJqIh3UhA6vzCfSpqgMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesnK9y50h3_45Wsaj3zAcLXActmNbc91_45f_45fzCAVKJ8yIDYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexT7x9jd_t1bV7dEeyDiYM1baNdUkUSMoAM7N_45FEw6CEkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/index.vue")
  },
  {
    name: hangoutttuuNhcO1HI2wvtAy2G_45SmCqNQLl54eD6oNbMPMsp_45EMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutttuuNhcO1HI2wvtAy2G_45SmCqNQLl54eD6oNbMPMsp_45EMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexgBibZHeCEkEk23SPbDl_454fezSv_NLtVJCRTWQf5rwZUMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaIpUDewCxJ88f_45BYMyLgqOA_45eG4JXha7gu4yYFXfq26gMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupshtqM5NamzHIzRibPtc57URPmK_qgbqzUHoi203tLwz8Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizequeyYLUrvgDMFhIzv0jW3Z_454NOfQC6sO_YfReA1WjS4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charte3aMTyDMmLxvMmf7VDb0KGLLd3YtYS60hNxK0dMqhBWQMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: francesDS47bji2edHg3ikxztBYt37bTnGQOFCvvxXF2Z_45rFEMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesDenwjJ2Cme_45DhP_BwgaH8PGzmdkke6_45r2Jiuun83qo4Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/themes.vue")
  },
  {
    name: insidersPpvlv2fzAvraWx0EHlE62jZ2bI4dN1nnF8NrNCz1N8IMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersPpvlv2fzAvraWx0EHlE62jZ2bI4dN1nnF8NrNCz1N8IMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionslLdwprSP1_45a_45eCpDQ5z6wRlG3wyZ9A5zwAooFXp1BL0Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messages_45s7L2okk2Jr46VrNClHmxalkEMtYefoyZIFgv_45WK6d4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacyVgRgymIndLq5_CSlWwUBZqcvubAFIe_45WxptwRcl_45jeIMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerMhAd7p_45EJ6W1EKpt1jobajKlsEJLOC_Uv9WIFNm7paAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/trainer.vue")
  },
  {
    name: communityQZspTEX4UbIUwak4KsoiUYbEVaNhQah2jhztr5zru64Meta?.name,
    path: "/app/community",
    meta: { ...(communityQZspTEX4UbIUwak4KsoiUYbEVaNhQah2jhztr5zru64Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexvSKHjvU_45SyLW6gf_bBLyfR412OaOE0GlA6cVUfz2T8wMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchTv8_9YKNC1xmJtWkxljngmkwfxr4_45T6gANEGYJ5ikwEMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    component: () => import("/tmp/build_6916f5cc/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexPEuymqSpL3bkebX9oTCNzAh0WTXlU_45UfYr_tKFJ9QJ4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: _91id_93zLbhPri29sWk407EJlIwdRhuKiYqtVQ2N4MqXut3MEwMeta?.name,
    path: "/app/quiz/:id()",
    meta: { ...(_91id_93zLbhPri29sWk407EJlIwdRhuKiYqtVQ2N4MqXut3MEwMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/quiz/[id].vue"),
    children: [
  {
    name: "app-quiz-id",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/quiz/[id]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexzbcgECOChgRyLKwYEp6E4NoeSd3RneYl0mXSSQoj_QQMeta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/auth/index.vue")
  },
  {
    name: onboardingUncLjBNVsnRLIz8kQU2V6FN17WWv1xG3XHhwSgxNUu0Meta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardingUncLjBNVsnRLIz8kQU2V6FN17WWv1xG3XHhwSgxNUu0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexYuLG806sLyRSp44cmuoyvVYJ7mGyQ4INu9EV9f1HAcAMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_6916f5cc/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "app-quiz",
    path: "/app/quiz",
    meta: { ...(indexeUdh4JFV0Q2jNBdSYoBv5InFV1KrU8ehX_JL074VR4kMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/quiz/index.vue")
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investorsqxlgzg9L13T_45nu9cUL2oLEN4HFSZ9mrb258fgXywOJEMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93SP5WrbJQEfSXwNT2i4AWtLcPXG9kM0nZHYqvAB2PsHkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastyKPvCXjtPetUoYV3aiAmeacfIZ3U1WxX6SPJHD5VY4sMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: deletepjl1o6kT244cG85Sz_qpaNyv_45dOjqOoFbIjTLjhLXwYMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutMaAuqssJhs_45RqxdPCdT7WPzz16zYyXvEBt7uPFFaPjYMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexjGLdJ5f492Mn0NbEE6OJwT8uIAPP3jPCUCKGSBQQMfIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexr_45NbgyqCGU0uRanLAlWE_Ltn_ZZIHx_45ikOoIzuJ3qAoMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_6916f5cc/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: indexs3j5GGvZ2jep06OrTLHnu3P8ufGElbYhXsftfxULlNgMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexKMzEa4grTvg5WUl__45pB8WQeg8ELpQc3vUvZ1kwecjnwMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexglbtBRvQhKmcBonmgWlnEu8tdJd0anzdEnCPdDJrpeYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_6916f5cc/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93gy1s3_45UK1pbibc1wVrSJgEL5L4eZD0ktEgvy6_45vxZ2cMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: index8v14M9Laf6h8WvaN7bhwCdX88gEjWtRh8j8TeSyvph8Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93_M_SKBpxMGHL9ttfaXQY7FNmQKrT5kUjbqWnHeU_4543QMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/payments/[token].vue")
  },
  {
    name: _91slug_93NNToJhfSOwY9WjrhNeztQul2QFPxOtufG5ZQNcPbCzIMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93NNToJhfSOwY9WjrhNeztQul2QFPxOtufG5ZQNcPbCzIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: editrhBWUdZELrtrT2Ncsmbv_MGDZyWjgrf0vRRVumfjuWMMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createm1b0BB_45fBfQRjjYuxa9yHwLGUi5JY5LuljzGQc4s1BQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(listMeocdr7_45kTEmf4wy_VNwwVYMtJlmiBBNomBA_45yEHLQQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_93WLck9CZzsNfM6p5D7OHkXtceYWWdtBIkxIdUYy2afwsMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93_WwvbOY70KPD19JQbBaq9hBfpOPVxjmmnZHtkPkTdMIMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93KiIqlQO7rba_45NAmpvd6sRisoZrC8b9M6R9CWlRzBE3IMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93eLJobskSEkXRS4YChIY2UUgesVmQG4RdduT7NKn6hk4Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_6916f5cc/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizations4pYPRdu3uLBqetDcPLMctd__451u4TVd3B92kvFoQNaRkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexapu9_fUNIfaKvvlmqQcblKMdvgiHWQs8Agzb__45guUqQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsFPxHZkcl16hPsU_LvUQfyeCZWrv0VNB9D_45E_45iKJQoz4Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_6916f5cc/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencesMcdVzZXYCaRQTOvE_F9V_45anj7ODy_mYDombFgVQItxIMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginkgmBYbeUCq2pikKy_wOsoz27kND8NUEVNB8RxXWPRU8Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93w_Sso8dtmrvfZQ_45DodSxhMasmuXetQU4YLaROR_45kA1UMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutaJhfs1HXsAwgTwOxr2t2POqxOvf29Dvzkty5k9hQunwMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_6916f5cc/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(listCSHzwSfKnnzGEQ_45DucCQR1Y_45oiyQita2J_7KLihtvHEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93Kktj0_8S3337exocalhtiAKkj77A6CXdm_45ae5zR9XzwMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registerixmnpsf8LZeW9M6hGgaSiMLuESobPyaQ6wXewDQFpMIMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93d23Xa5XFrHyg_45327XIZjRB_453NYe_45feHHl3JCm_OXiwwMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discordqIT22_45RRniyj8lLqSOibr7F0KfWwlB_kKpdXFFUbcX0Meta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexwqkxYfKgTb20UUPoxN4IUpejG9stt8vCxCrDUdQVFLIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentesv9uPQmHe_FFk7IU8oM202_Z1XPo_5ILJE8VYic5jAeUMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45auth0iracEJHkrcK_45zs3aavUl8pkfG0TQJVxyq9b8a6wK6AMeta || {},
    component: () => import("/tmp/build_6916f5cc/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribeSvtgoMY59dUk6IybEGbX8pnRZzDcH4webttVqSYpiA4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexXNfHwGwaCke5QZxUJJQ0g24WvOxQYRpG5n1zmKNZkjkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexMI8yEIWQrDCCw0S8ko9TZYS8fB_453YYP27qjelocpP7UMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93b7xcRW2xfSiu20ZLOuVJ0kh_45IVoqmAtc9_45_dmOOdTccMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: editfu3c086jzLShaVxVnBuFSx2j50tv7JqphtUN5HvB84cMeta?.name,
    path: "edit",
    meta: { ...(editfu3c086jzLShaVxVnBuFSx2j50tv7JqphtUN5HvB84cMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexq0py71Shokz3sfU_omHDvKAZtKeN25Y1ZySnZCkSNbkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesv9oHrICOLSW49jhrVCo6ky6jpPjgPtuii72iSi59ADIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(creategxdSbu1_45Lv3o8V_456FSNwLCRDM4L3CbXpt9s_45fo8vE8UMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(index1FbxpxZkK3ktxjmGe7tfFJ_4Wp_fOP0boUJ5mKrbPdYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(index8mtCbOvq7bddswHg1N8baO0aZu_RjljnsJ9EmwTM1ekMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_6916f5cc/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stubnzBTqPYdGdmX1a5fprjyTe12naLBvBOqUEht6uPTwoYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubnzBTqPYdGdmX1a5fprjyTe12naLBvBOqUEht6uPTwoY
  }
]